module.exports = __webpack_public_path__ + "img/icon_btc_defult.72c65fa4.svg";